module.exports = __webpack_public_path__ + "static/media/other-issue-icon.c69a892b.svg";